import {Column} from 'react-table'
import {columnGenerators} from '../../../../_metronic/helpers'
export const header = [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Category',
    value: 'categoryName-c',
  },
  {
    label: 'Item',
    value: 'itemName-c',
  },
  {
    label: 'Quality Collected',
    value: 'itemQuantity-c',
  },
  {
    label: 'GHG Saved',
    value: 'co2savings-c',
  },
  {
    label: 'Energy Saved',
    value: 'energySavings-c',
  },
  {
    label: 'Water Saved',
    value: 'waterSavings-c',
  },
  {
    label: 'Tress Saved',
    value: 'treeSavings-c',
  },
  // {
  //   action: ['view', 'id', 'qr'],
  // },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export {roleColumns}
